var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.node.parameters, function(param, index) {
        return [
          _c("div", { key: index }, [
            _c("label", { staticClass: "control-label" }, [
              _vm._v("\n        " + _vm._s(param.displayName) + " "),
              !param.isOptional ? _c("span", [_vm._v("*")]) : _vm._e(),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.top",
                    value: param.description,
                    expression: "param.description",
                    modifiers: { top: true }
                  }
                ],
                staticClass: "fa fa-question-circle m-l-5",
                attrs: { "aria-hidden": "true" }
              })
            ])
          ])
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cf-node-properties__field" },
        [
          _c("PrismEditor", {
            attrs: { highlight: _vm.highlighter, "line-mumbers": false },
            on: { input: _vm.inputChange },
            model: {
              value: _vm.settings.script,
              callback: function($$v) {
                _vm.$set(_vm.settings, "script", $$v)
              },
              expression: "settings.script"
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }